module.exports = __webpack_public_path__ + "static/media/randalls.7ffba8ab.svg";